import styled from 'styled-components';

const Container = styled.div`
  max-width: 720px;
  margin: auto;
`;

export default Container;
